import { Controller } from 'stimulus';

const CLASS_HIDDEN = 'd-none';

/**
 * Augments a link to download a file from our server, adding a feedback modal for the user.
 *
 * Attach to the body element and use the `shared/modals/loading_modal` partial to show
 * a loading modal. This controller will close the modal & download the file when ready, and
 * handle errors
 */
export default class extends Controller {
  static targets = ['modalCloseButton', 'downloadingMessage', 'errorMessage'];
  static values = {
    modalId: { type: String, default: 'loading_modal' },
  };

  connect() {
    this.modalCloseButtonTarget.classList.add(CLASS_HIDDEN);
  }

  async fetchFile(event) {
    event.preventDefault();

    try {
      const opener = event.currentTarget;
      const url = opener.href;
      const response = await fetch(url);

      if (response.ok) {
        const blob = await response.blob();

        this.closeModal(opener);
        this.downloadFile(blob);
      } else {
        throw new Error(response.statusText);
      }
    } catch (error) {
      this.showErrorMessage();
      window.sendError('Error downloading file', error);
    }
  }

  downloadFile(blob) {
    const URL = window.URL || window.webkitURL;
    const file = URL.createObjectURL(blob);
    window.location.assign(file);
  }

  closeModal(opener) {
    opener.dispatchEvent(
      new CustomEvent('close_modal', {
        bubbles: true,
        detail: { modal_id: this.modalIdValue },
      })
    );
  }

  showErrorMessage() {
    this.downloadingMessageTarget.classList.add(CLASS_HIDDEN);
    this.errorMessageTarget.classList.remove(CLASS_HIDDEN);
    this.modalCloseButtonTarget.classList.remove(CLASS_HIDDEN);
  }

  resetModal() {
    this.downloadingMessageTarget.classList.remove(CLASS_HIDDEN);
    this.errorMessageTarget.classList.add(CLASS_HIDDEN);
    this.modalCloseButtonTarget.classList.add(CLASS_HIDDEN);
  }
}
